"use strict";

exports.__esModule = true;
exports.shadowClasses = exports.positionClasses = exports.overflowClasses = exports.borderRadiusClasses = exports.SHADOWS = exports.POSITION = exports.OVERFLOW = exports.BORDER_RADIUS = void 0;
var _mediaQuery = require("../../utils/mediaQuery");
let POSITION = exports.POSITION = /*#__PURE__*/function (POSITION) {
  POSITION["ABSOLUTE"] = "absolute";
  POSITION["RELATIVE"] = "relative";
  POSITION["FIXED"] = "fixed";
  return POSITION;
}({});
const positionClasses = exports.positionClasses = {
  [POSITION.ABSOLUTE]: "absolute",
  [POSITION.RELATIVE]: "relative",
  [POSITION.FIXED]: "fixed",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [POSITION.ABSOLUTE]: "ld:absolute",
    [POSITION.RELATIVE]: "ld:relative",
    [POSITION.FIXED]: "ld:fixed"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [POSITION.ABSOLUTE]: "de:absolute",
    [POSITION.RELATIVE]: "de:relative",
    [POSITION.FIXED]: "de:fixed"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [POSITION.ABSOLUTE]: "tb:absolute",
    [POSITION.RELATIVE]: "tb:relative",
    [POSITION.FIXED]: "tb:fixed"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [POSITION.ABSOLUTE]: "lm:absolute",
    [POSITION.RELATIVE]: "lm:relative",
    [POSITION.FIXED]: "lm:fixed"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [POSITION.ABSOLUTE]: "mm:absolute",
    [POSITION.RELATIVE]: "mm:relative",
    [POSITION.FIXED]: "mm:fixed"
  }
};
let SHADOWS = exports.SHADOWS = /*#__PURE__*/function (SHADOWS) {
  SHADOWS["ACTION"] = "action";
  SHADOWS["FIXED"] = "fixed";
  SHADOWS["RAISED"] = "raised";
  SHADOWS["OVERLAY"] = "overlay";
  SHADOWS["FIXED_REVERSE"] = "fixedReverse";
  SHADOWS["RAISED_REVERSE"] = "raisedReverse";
  return SHADOWS;
}({});
const shadowClasses = exports.shadowClasses = {
  [SHADOWS.ACTION]: "shadow-action",
  [SHADOWS.FIXED]: "shadow-fixed",
  [SHADOWS.RAISED]: "shadow-raised",
  [SHADOWS.OVERLAY]: "shadow-overlay",
  [SHADOWS.FIXED_REVERSE]: "shadow-fixed-reverse",
  [SHADOWS.RAISED_REVERSE]: "shadow-raised-reverse",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [SHADOWS.ACTION]: "ld:shadow-action",
    [SHADOWS.FIXED]: "ld:shadow-fixed",
    [SHADOWS.RAISED]: "ld:shadow-raised",
    [SHADOWS.OVERLAY]: "ld:shadow-overlay",
    [SHADOWS.FIXED_REVERSE]: "ld:shadow-fixed-reverse",
    [SHADOWS.RAISED_REVERSE]: "ld:shadow-raised-reverse"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [SHADOWS.ACTION]: "de:shadow-action",
    [SHADOWS.FIXED]: "de:shadow-fixed",
    [SHADOWS.RAISED]: "de:shadow-raised",
    [SHADOWS.OVERLAY]: "de:shadow-overlay",
    [SHADOWS.FIXED_REVERSE]: "de:shadow-fixed-reverse",
    [SHADOWS.RAISED_REVERSE]: "de:shadow-raised-reverse"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [SHADOWS.ACTION]: "tb:shadow-action",
    [SHADOWS.FIXED]: "tb:shadow-fixed",
    [SHADOWS.RAISED]: "tb:shadow-raised",
    [SHADOWS.OVERLAY]: "tb:shadow-overlay",
    [SHADOWS.FIXED_REVERSE]: "tb:shadow-fixed-reverse",
    [SHADOWS.RAISED_REVERSE]: "tb:shadow-raised-reverse"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [SHADOWS.ACTION]: "lm:shadow-action",
    [SHADOWS.FIXED]: "lm:shadow-fixed",
    [SHADOWS.RAISED]: "lm:shadow-raised",
    [SHADOWS.OVERLAY]: "lm:shadow-overlay",
    [SHADOWS.FIXED_REVERSE]: "lm:shadow-fixed-reverse",
    [SHADOWS.RAISED_REVERSE]: "lm:shadow-raised-reverse"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [SHADOWS.ACTION]: "mm:shadow-action",
    [SHADOWS.FIXED]: "mm:shadow-fixed",
    [SHADOWS.RAISED]: "mm:shadow-raised",
    [SHADOWS.OVERLAY]: "mm:shadow-overlay",
    [SHADOWS.FIXED_REVERSE]: "mm:shadow-fixed-reverse",
    [SHADOWS.RAISED_REVERSE]: "mm:shadow-raised-reverse"
  }
};
let BORDER_RADIUS = exports.BORDER_RADIUS = /*#__PURE__*/function (BORDER_RADIUS) {
  BORDER_RADIUS["SMALL"] = "small";
  BORDER_RADIUS["NORMAL"] = "normal";
  BORDER_RADIUS["LARGE"] = "large";
  BORDER_RADIUS["CIRCLE"] = "circle";
  return BORDER_RADIUS;
}({});
const borderRadiusClasses = exports.borderRadiusClasses = {
  [BORDER_RADIUS.SMALL]: "rounded-small",
  [BORDER_RADIUS.NORMAL]: "rounded-normal",
  [BORDER_RADIUS.LARGE]: "rounded-large",
  [BORDER_RADIUS.CIRCLE]: "rounded-full",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [BORDER_RADIUS.SMALL]: "ld:rounded-small",
    [BORDER_RADIUS.NORMAL]: "ld:rounded-normal",
    [BORDER_RADIUS.LARGE]: "ld:rounded-large",
    [BORDER_RADIUS.CIRCLE]: "ld:rounded-full"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [BORDER_RADIUS.SMALL]: "de:rounded-small",
    [BORDER_RADIUS.NORMAL]: "de:rounded-normal",
    [BORDER_RADIUS.LARGE]: "de:rounded-large",
    [BORDER_RADIUS.CIRCLE]: "de:rounded-full"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [BORDER_RADIUS.SMALL]: "tb:rounded-small",
    [BORDER_RADIUS.NORMAL]: "tb:rounded-normal",
    [BORDER_RADIUS.LARGE]: "tb:rounded-large",
    [BORDER_RADIUS.CIRCLE]: "tb:rounded-full"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [BORDER_RADIUS.SMALL]: "lm:rounded-small",
    [BORDER_RADIUS.NORMAL]: "lm:rounded-normal",
    [BORDER_RADIUS.LARGE]: "lm:rounded-large",
    [BORDER_RADIUS.CIRCLE]: "lm:rounded-full"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [BORDER_RADIUS.SMALL]: "mm:rounded-small",
    [BORDER_RADIUS.NORMAL]: "mm:rounded-normal",
    [BORDER_RADIUS.LARGE]: "mm:rounded-large",
    [BORDER_RADIUS.CIRCLE]: "mm:rounded-full"
  }
};
let OVERFLOW = exports.OVERFLOW = /*#__PURE__*/function (OVERFLOW) {
  OVERFLOW["AUTO"] = "auto";
  OVERFLOW["HIDDEN"] = "hidden";
  OVERFLOW["SCROLL"] = "scroll";
  OVERFLOW["VISIBLE"] = "visible";
  return OVERFLOW;
}({});
const overflowClasses = exports.overflowClasses = {
  [OVERFLOW.AUTO]: "overflow-auto",
  [OVERFLOW.HIDDEN]: "overflow-hidden",
  [OVERFLOW.SCROLL]: "overflow-scroll",
  [OVERFLOW.VISIBLE]: "overflow-visible",
  [_mediaQuery.QUERIES.LARGEDESKTOP]: {
    [OVERFLOW.AUTO]: "ld:overflow-auto",
    [OVERFLOW.HIDDEN]: "ld:overflow-hidden",
    [OVERFLOW.SCROLL]: "ld:overflow-scroll",
    [OVERFLOW.VISIBLE]: "ld:overflow-visible"
  },
  [_mediaQuery.QUERIES.DESKTOP]: {
    [OVERFLOW.AUTO]: "de:overflow-auto",
    [OVERFLOW.HIDDEN]: "de:overflow-hidden",
    [OVERFLOW.SCROLL]: "de:overflow-scroll",
    [OVERFLOW.VISIBLE]: "de:overflow-visible"
  },
  [_mediaQuery.QUERIES.TABLET]: {
    [OVERFLOW.AUTO]: "tb:overflow-auto",
    [OVERFLOW.HIDDEN]: "tb:overflow-hidden",
    [OVERFLOW.SCROLL]: "tb:overflow-scroll",
    [OVERFLOW.VISIBLE]: "tb:overflow-visible"
  },
  [_mediaQuery.QUERIES.LARGEMOBILE]: {
    [OVERFLOW.AUTO]: "lm:overflow-auto",
    [OVERFLOW.HIDDEN]: "lm:overflow-hidden",
    [OVERFLOW.SCROLL]: "lm:overflow-scroll",
    [OVERFLOW.VISIBLE]: "lm:overflow-visible"
  },
  [_mediaQuery.QUERIES.MEDIUMMOBILE]: {
    [OVERFLOW.AUTO]: "mm:overflow-auto",
    [OVERFLOW.HIDDEN]: "mm:overflow-hidden",
    [OVERFLOW.SCROLL]: "mm:overflow-scroll",
    [OVERFLOW.VISIBLE]: "mm:overflow-visible"
  }
};